module.exports = __webpack_public_path__ + "static/media/li.fb5437d3.svg";